import { PAIN_POINTS } from "@/lib/constants";
import { PhoneOff, Hourglass, FileStack, CircleDollarSign } from "lucide-react";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

const iconMap = { PhoneOff, Clock: Hourglass, FileX: FileStack, TrendingDown: CircleDollarSign };

export default function PainPoints() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section
      data-testid="pain-points-section"
      className="bg-[#F9FAFB] py-16 md:py-24"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <h2
          className="font-heading text-3xl md:text-5xl font-semibold text-[#1A1A1A] text-center tracking-tight mb-12 md:mb-16"
        >
          {PAIN_POINTS.heading}
        </h2>

        <div
          ref={ref}
          className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8"
        >
          {PAIN_POINTS.cards.map((card, i) => {
            const Icon = iconMap[card.icon];
            return (
              <div
                key={card.title}
                data-testid={`pain-point-card-${i}`}
                className={`bg-white border border-gray-200 rounded-xl p-6 md:p-8 transition-all duration-500 hover:border-red-200 hover:shadow-md ${
                  isVisible
                    ? "opacity-100 translate-y-0"
                    : "opacity-0 translate-y-6"
                }`}
                style={{ transitionDelay: `${i * 100}ms` }}
              >
                <div className="w-10 h-10 rounded-lg bg-red-50 flex items-center justify-center mb-4">
                  {Icon && <Icon className="h-5 w-5 text-red-500" />}
                </div>
                <h3 className="font-heading text-xl font-semibold text-[#1A1A1A] mb-2">
                  {card.title}
                </h3>
                <p className="text-[#6B7280] text-sm leading-relaxed">
                  {card.body}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
